import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GoogleAnalytics = () => {
  const [gaId, setGaId] = useState(null);

  useEffect(() => {
    const fetchGaId = async () => {
      try {
        const response = await axios.get(`${API}/settings/public`);
        const id = response.data.google_analytics_id;
        if (id && id.trim()) {
          setGaId(id.trim());
        }
      } catch (error) {
        console.error('Failed to fetch GA settings:', error);
      }
    };
    fetchGaId();
  }, []);

  useEffect(() => {
    if (!gaId) return;

    // Check if script already exists
    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${gaId}"]`)) return;

    // Load gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    // Initialize gtag
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}');
    `;
    document.head.appendChild(inlineScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, [gaId]);

  return null;
};

export default GoogleAnalytics;
